var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c("b-col", [_c("h4", [_vm._v("Despesas")])]),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "text-right" },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "secondary", size: "sm" },
                  on: {
                    click: function($event) {
                      return _vm.voltar()
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fas fa-arrow-left" }),
                  _vm._v(" Voltar")
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { attrs: { "align-v": "end" } },
        [
          _c(
            "b-col",
            [
              _c("label", { attrs: { for: "" } }, [_vm._v("De")]),
              _vm._v(" "),
              _c("date-picker", {
                attrs: {
                  config: _vm.datePickerConfig,
                  placeholder: "Data de:"
                },
                model: {
                  value: _vm.filtro.fromDate,
                  callback: function($$v) {
                    _vm.$set(_vm.filtro, "fromDate", $$v)
                  },
                  expression: "filtro.fromDate"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c("label", { attrs: { for: "" } }, [_vm._v("Ate")]),
              _vm._v(" "),
              _c("date-picker", {
                attrs: {
                  config: _vm.datePickerConfig,
                  placeholder: "Data até:"
                },
                model: {
                  value: _vm.filtro.toDate,
                  callback: function($$v) {
                    _vm.$set(_vm.filtro, "toDate", $$v)
                  },
                  expression: "filtro.toDate"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c("label", { attrs: { for: "" } }, [_vm._v("Despesa")]),
              _vm._v(" "),
              _c("b-form-select", {
                attrs: { options: _vm.optionsDespesa },
                model: {
                  value: _vm.filtro.despesa,
                  callback: function($$v) {
                    _vm.$set(_vm.filtro, "despesa", $$v)
                  },
                  expression: "filtro.despesa"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c("label", { attrs: { for: "" } }, [_vm._v("Usuário")]),
              _vm._v(" "),
              _c("b-form-select", {
                attrs: { options: _vm.listUsuarios },
                model: {
                  value: _vm.filtro.usuario,
                  callback: function($$v) {
                    _vm.$set(_vm.filtro, "usuario", $$v)
                  },
                  expression: "filtro.usuario"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c("label", { attrs: { for: "" } }, [_vm._v("Status")]),
              _vm._v(" "),
              _c("b-form-select", {
                attrs: { options: _vm.listStatus },
                model: {
                  value: _vm.filtro.status,
                  callback: function($$v) {
                    _vm.$set(_vm.filtro, "status", $$v)
                  },
                  expression: "filtro.status"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c(
                "b-button",
                {
                  attrs: { title: "Buscar", variant: "primary" },
                  on: { click: _vm.loadDespesas }
                },
                [_c("i", { staticClass: "fa fa-search" })]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "ml-2",
                  attrs: { title: "Limpar Filtro", variant: "secondary" },
                  on: {
                    click: function($event) {
                      return _vm.limpaFiltro()
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-history" })]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { staticClass: "text-right" }, [
            _vm.totalDespesa > 0
              ? _c("h3", { staticClass: "text-primary" }, [
                  _vm._v(
                    "Total em despesas: R$ " +
                      _vm._s(_vm.totalDespesa.toFixed(2))
                  )
                ])
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-3" },
        [
          _c("b-table", {
            attrs: {
              items: _vm.despesas,
              fields: _vm.fields,
              busy: _vm.loading,
              hover: "",
              striped: "",
              small: "",
              stacked: "md",
              "show-empty": "",
              "empty-text": "Nenhuma despesa encontrada ..."
            },
            scopedSlots: _vm._u([
              {
                key: "cell(actions)",
                fn: function(row) {
                  return [
                    _c("div", { staticClass: "custom-actions" }, [
                      _c(
                        "div",
                        { staticClass: "btn-group" },
                        [
                          row.item.status === "PENDENTE"
                            ? _c(
                                "b-button",
                                {
                                  attrs: {
                                    title: "Aprovar Despesa",
                                    variant: "success",
                                    size: "sm"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.aprova(
                                        row.item.id,
                                        row.item.valor
                                      )
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fa fa-thumbs-up" })]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          row.item.status === "APROVADO"
                            ? _c(
                                "b-button",
                                {
                                  attrs: {
                                    title: "Visualizar Despesa",
                                    variant: "secondary",
                                    size: "sm"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.visualizar(row.item.id)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fas fa-eye" })]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          row.item.status === "PENDENTE"
                            ? _c(
                                "b-button",
                                {
                                  attrs: {
                                    variant: "primary",
                                    size: "sm",
                                    title: "Editar Despesa"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.edit(row.item.id)
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fa fa-edit" })]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "modal fade",
                          attrs: {
                            id: "actionModal",
                            tabindex: "-1",
                            role: "dialog",
                            "aria-labelledby": "actionModal"
                          }
                        },
                        [
                          _c("div", {
                            staticClass: "modal-dialog modal-lg",
                            attrs: { role: "document" }
                          })
                        ]
                      )
                    ])
                  ]
                }
              },
              {
                key: "cell(status)",
                fn: function(row) {
                  return [
                    row.item.status == "APROVADO"
                      ? _c("b-badge", { attrs: { variant: "success" } }, [
                          _vm._v("Aprovada")
                        ])
                      : _c("b-badge", { attrs: { variant: "warning" } }, [
                          _vm._v("Pendente")
                        ])
                  ]
                }
              },
              {
                key: "table-busy",
                fn: function() {
                  return [
                    _c(
                      "div",
                      { staticClass: "text-center text-primary my-2" },
                      [
                        _c("b-spinner", { staticClass: "align-middle" }),
                        _vm._v(" "),
                        _c("strong", [_vm._v("Carregando Despesas ...")])
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _vm.rows > 15
            ? _c("b-pagination", {
                attrs: { "total-rows": _vm.rows, "per-page": _vm.perPage },
                on: {
                  input: function($event) {
                    return _vm.loadDespesas()
                  }
                },
                model: {
                  value: _vm.currentPage,
                  callback: function($$v) {
                    _vm.currentPage = $$v
                  },
                  expression: "currentPage"
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { size: "lg" },
          scopedSlots: _vm._u([
            {
              key: "modal-header",
              fn: function() {
                return [_c("h4", [_vm._v(_vm._s(_vm.despesa.user))])]
              },
              proxy: true
            },
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _vm.editarDespesa
                    ? _c(
                        "b-button",
                        {
                          attrs: { size: "sm", variant: "primary" },
                          on: { click: _vm.saveDespesa }
                        },
                        [
                          _c("i", { staticClass: "fas fa-save" }),
                          _vm._v(" Salvar")
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "danger" },
                      on: {
                        click: function($event) {
                          _vm.modalDespesas = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.editarDespesa ? "Cancelar" : "Fechar"))]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.modalDespesas,
            callback: function($$v) {
              _vm.modalDespesas = $$v
            },
            expression: "modalDespesas"
          }
        },
        [
          _c(
            "div",
            { staticClass: "container" },
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-card-body",
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", [_vm._v(" Tipo de Despesa")]),
                                _vm._v(" "),
                                _c("v-select", {
                                  attrs: {
                                    disabled: !_vm.editarDespesa,
                                    options: _vm.listDespesa
                                  },
                                  model: {
                                    value: _vm.despesa.tipo,
                                    callback: function($$v) {
                                      _vm.$set(_vm.despesa, "tipo", $$v)
                                    },
                                    expression: "despesa.tipo"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", [_vm._v("Valor R$")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.despesa.valor,
                                    expression: "despesa.valor"
                                  },
                                  {
                                    name: "mask",
                                    rawName: "v-mask",
                                    value: ["#.##", "##.##", "###.##"],
                                    expression: "['#.##', '##.##', '###.##']"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  disabled: !_vm.editarDespesa,
                                  type: "text"
                                },
                                domProps: { value: _vm.despesa.valor },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.despesa,
                                      "valor",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ]),
                          _vm._v(" "),
                          _c("b-col", [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", [_vm._v("Data ")]),
                                _vm._v(" "),
                                _c("date-picker", {
                                  attrs: {
                                    disabled: !_vm.editarDespesa,
                                    config: _vm.datePickerConfig
                                  },
                                  model: {
                                    value: _vm.despesa.data,
                                    callback: function($$v) {
                                      _vm.$set(_vm.despesa, "data", $$v)
                                    },
                                    expression: "despesa.data"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _c("div", { staticClass: "form-group" }, [
                              _c("label", [_vm._v("OBS")]),
                              _vm._v(" "),
                              _c("small", [
                                _vm._v(
                                  "Em caso de Outros, este campo é obrigatório."
                                )
                              ]),
                              _vm._v(" "),
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.despesa.obs,
                                    expression: "despesa.obs"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { disabled: !_vm.editarDespesa },
                                domProps: { value: _vm.despesa.obs },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.despesa,
                                      "obs",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          !_vm.despesa.nota && _vm.editarDespesa
                            ? _c("b-col", [
                                _c("div", { staticClass: "form-group" }, [
                                  _c("label", [
                                    _vm._v("Cupom Fiscal/Nota Fiscal ")
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    staticClass: "form-control",
                                    attrs: {
                                      disabled: !_vm.editarDespesa,
                                      type: "file",
                                      accept: "image/jpeg, image/png"
                                    },
                                    on: { change: _vm.loadFile }
                                  })
                                ])
                              ])
                            : _vm.despesa.nota
                            ? _c("b-col", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "/" + _vm.despesa.nota,
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "img-thumbnail",
                                      attrs: {
                                        src: "/" + _vm.despesa.nota,
                                        width: "300"
                                      }
                                    })
                                  ]
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6431a940", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6431a940","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/rotas/adm/List.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6431a940","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/rotas/adm/List.vue
// module chunks = 2